import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { SnackBarService } from './snack-bar.service';
import { isNumeric } from 'rxjs/internal-compatibility';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable()
export class ExcelService {

  constructor(private notification: SnackBarService) { }

  public exportAsExcelFiles(json: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }
  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
    this.notification.success(`${fileName}: exported successfully.`, 'Export', 'cloud_download');
  }

  public exportDatatoExcel(data: any, dataArr: any, reportName) {
    const arr = [];
    data.forEach(t => {
      let dt = {};
      dataArr.forEach(element => {
        dt[element.headerName] = isNumeric(t[element.displayName]) ? String(t[element.displayName]) : t[element.displayName];
      });
      arr.push(dt);
    });
    this.exportAsExcelFiles(arr, ((reportName) ? reportName : 'report'));
  }
}
